const getYearsLabel = () => {
  const years = []
  for (let i = 1929; i < 2022; i++) {
    years.push(i)
  }
  return years.reverse()
}

const getMonthsLabel = () => {
  const months = []
  for (let i = 0; i < 12; i++) {
    months.push(i + 1)
  }
  return months
}

const getDatesLabel = () => {
  const dates = []
  for (let i = 0; i < 31; i++) {
    dates.push(i + 1)
  }
  return dates
}

export {
  getYearsLabel,
  getMonthsLabel,
  getDatesLabel
}
